import type React from 'react';

import { OrdCreateInDialogButton, OrdEditInDialogButton } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { UserNumberFields } from '@ragu-components/ord-types';
import { RecordContextProvider, ReferenceManyField, WrapperField } from 'react-admin';

import { UserNumberList } from '../userNumbers/UserNumberList';
import { UserNumbersForm } from '../userNumbers/UserNumbersForm';

import type { UserRead } from '@ragu-components/ord-types';

export const UserNumbersTab = ({ user }: { user: UserRead }): React.ReactElement => {
  const createButton = (
    <OrdCreateInDialogButton inline fullWidth>
      <UserNumbersForm embedded defaultValues={{ owner: user.id }} />
    </OrdCreateInDialogButton>
  );

  const editButton = (
    <OrdEditInDialogButton mutationMode='pessimistic' fullWidth>
      <UserNumbersForm embedded />
    </OrdEditInDialogButton>
  );

  return (
    <RecordContextProvider value={user}>
      <ReferenceManyField target={UserNumberFields['owner.id']} reference={Resources.user_numbers}>
        <UserNumberList
          embeddedChildren={<WrapperField label={createButton}>{editButton}</WrapperField>}
          layout='embedded'
          empty={createButton}
        />
      </ReferenceManyField>
    </RecordContextProvider>
  );
};
